export const getCustomDropdownStyle = (components, { palette = {} } = {}) => ({
  customDropdownContainer: {
    position: 'relative',

    '& .custom-dropdown-caretdown-selected': {
      fontSize: 12,
      pointerEvent: 'none',
      color: palette.themeDark,
    },
  },
});
